module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bIcq1"))).then(() => parcelRequire('cvs7o'));